var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.26 193.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #none;\n      }\n\n      .cls-2 {\n        opacity:1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.82.12l-4.71,2.62L45.45,90.41c-2.81,3.84-2.76,8.51.19,12.25l87.47,87.47c9.43,8.03,21.63-3.95,13.9-13.52l-79.89-80.3L147.01,16.27c4.95-6.46,2.05-13.78-5.42-16.15h51.54v193.01H.12V.12h137.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.59.12c7.48,2.36,10.37,9.69,5.42,16.15l-79.89,80.03,79.89,80.3c7.73,9.58-4.47,21.55-13.9,13.52L45.64,102.66c-2.94-3.74-2.99-8.4-.19-12.25L133.11,2.75l4.71-2.62h3.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.7cddcf8b56293ef1a75d8254bf8a7984.svg";
export { ForwardRef as ReactComponent };